import { render } from "./TheCartAddedProductCard.vue?vue&type=template&id=387f0b71"
import script from "./TheCartAddedProductCard.vue?vue&type=script&lang=js"
export * from "./TheCartAddedProductCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__